"use strict";
const _ = require("lodash");
const MultipleComboBoxControlComponent = require("../multiple/MultipleComboBoxControlComponent");
const Renderer = require("../IconComboBoxControlRenderer");

class IconMultipleComboBoxControlComponent extends MultipleComboBoxControlComponent {
    /**
     * @schema.name Icon Combo Box Control
     * @schema.package @gluenetworks/combobox
     * @schema.packageIdentifier Icon.Multiple
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.OptionSelection.Multiple.Icon.ComboBox
     * @schema.events ["Placeholder", "Autoselect", "DropUp", "ShowFilter", "Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default ""
     * @schema.configuration.placeholder.required false
     *
     * @schema.configuration.autoselect.name autoselect
     * @schema.configuration.autoselect.type boolean
     * @schema.configuration.autoselect.default false
     * @schema.configuration.autoselect.required false
     *
     * @schema.configuration.dropUp.name dropUp
     * @schema.configuration.dropUp.type boolean
     * @schema.configuration.dropUp.default false
     * @schema.configuration.dropUp.required false
     *
     * @schema.configuration.showFilter.name showFilter
     * @schema.configuration.showFilter.type boolean
     * @schema.configuration.showFilter.default true
     * @schema.configuration.showFilter.required false
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } },{ label: 'Number 6', value: { valueProp1: 'blah6', valueProp2: { somethin: 'somethin6' } } },{ label: 'Number 7', value: { valueProp1: 'blah7', valueProp2: { somethin: 'somethin7' } } }]
     *
     * @schema.configuration.value.example [{ valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }]
     *
     * @schema.configuration.optionIcon.name optionIcon
     * @schema.configuration.optionIcon.type string
     * @schema.configuration.optionIcon.default
     * @schema.configuration.optionIcon.required false
     *
     * @schema.configuration.selectedOptionIcon.name selectedOptionIcon
     * @schema.configuration.selectedOptionIcon.type string
     * @schema.configuration.selectedOptionIcon.default
     * @schema.configuration.selectedOptionIcon.required false
     */

    constructor(config) {
        super(config);
        this._optionIcon = _.get(config, "optionIcon", undefined);
        this._selectedOptionIcon = _.get(config, "selectedOptionIcon", undefined);
        this._renderer = new Renderer(this);
    }
    get optionIcon() {
        return this._optionIcon;
    }
    get selectedOptionIcon() {
        return this._selectedOptionIcon;
    }
}

module.exports = IconMultipleComboBoxControlComponent;
